<table class="table table-inner table-striped table-bordered order-summary-table">
  <thead>
    <tr>
      <th colspan="2" role="columnheader" aria-label="Order Details" tabindex="0">Order Details</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td role="gridcell" aria-label="Order Id" tabindex="0">Order Id:</td>
      <td role="gridcell" aria-label="Cell of Order Id" tabindex="0">{{workFlowOrderIdDesc}}</td>
    </tr>
    <tr>
      <td role="gridcell" aria-label="Order Status" tabindex="0">Order Status:</td>
      <td role="gridcell" aria-label="Cell of Order Status" tabindex="0">{{order ? order.orderStatus : ''}}</td>
    </tr>
    <tr>
      <td role="gridcell" aria-label="Revised Due Date" tabindex="0">Revised Due Date:</td>
      <td role="gridcell" aria-label="Cell of Revised Due Date" tabindex="0">{{(order ? order.confirmedDueDate : null) | dateToLocale }}</td>
    </tr>
    <tr>
      <td role="gridcell" aria-label="Actual Delivery Date" tabindex="0">Actual Delivery Date:</td>
      <td role="gridcell" aria-label="Cell of Actual Delivery Date" tabindex="0">{{(order? order.actualDeliveryDate : null) | dateToLocale }}</td>
    </tr>
    <tr *ngIf="whichStep != 'STEP1'">
      <td role="gridcell" aria-label="Order Type" tabindex="0">Order Type:</td>
      <td role="gridcell" aria-label="Cell of Order Type" tabindex="0">{{order ? order.serviceCategory : ''}}</td>
    </tr>
    <tr *ngIf="whichStep != 'STEP1'">
      <td role="gridcell" aria-label="Service Type:" tabindex="0">Service Type:</td>
      <td role="gridcell" aria-label="Cell of Service Type:" tabindex="0">{{serviceTypeDesc}}</td>
    </tr>
    <tr *ngIf="whichStep != 'STEP1'">
      <td role="gridcell" aria-label="Delivery Priority" tabindex="0">Delivery Priority:</td>
      <td role="gridcell" aria-label="Cell of Delivery Priority" tabindex="0">{{deliveryPrDesc}}</td>
    </tr>
    <tr *ngIf="whichStep != 'STEP1'">
      <td role="gridcell" aria-label="Order Name" tabindex="0">Order Name:</td>
      <td role="gridcell" aria-label="Cell of Order Name" tabindex="0">{{order ? order.orderName : ''}}</td>
    </tr>
    <tr *ngIf="whichStep != 'STEP1'">
      <td role="gridcell" aria-label="Order Owner" tabindex="0">Order Owner:</td>
      <td role="gridcell" aria-label="Cell of Order Owner" tabindex="0">{{orderOwnersDesc}}</td>
    </tr>
    <tr *ngIf="whichStep === 'STEP3'">
      <td role="gridcell" aria-label="Tracking Number" tabindex="0">Tracking Number:</td>
      <td role="gridcell" aria-label="Cell of Tracking Number" tabindex="0">{{order ? order.externalTrackingNumber : ''}}</td>
    </tr>
  </tbody>
</table>
